import React from "react";
import { EditablePageBlock } from "../page-block-list/editable-page-block";
import { PageBlockProps } from "../page-block-list/page-block";
import { AdditionalChecklistBlockData } from "models/interfaces/additional-block-data/additional-checklist-block-data";
import { useChecklistBlockChecklistItems } from "utilities/hooks/domain/block-configurations/use-checklist-block-checklist-items";

interface ChecklistBlockProps extends PageBlockProps {}

export const ChecklistBlock = (props: ChecklistBlockProps): JSX.Element => {
    const { items, onItemsReordered, updateItems } =
        useChecklistBlockChecklistItems(props.block.configuration);
    const additionalBlockData: AdditionalChecklistBlockData = {
        items: items,
        onItemsReordered: onItemsReordered,
        updateItems: updateItems,
    };

    return (
        <EditablePageBlock
            {...props}
            additionalBlockData={additionalBlockData}
        />
    );
};
